import { combineReducers } from 'redux';
import { advertisementReducer, AdvertisementStore } from './advertisementReducer';
import { campaignReducer, CampaignStore } from './campaignReducer';
import { deviceTypeReducer, DeviceTypeStore } from './deviceTypeReducer';
import { errorHandlerReducer, ErrorHandlerStore } from './errorHandlerReducer';
import { PopupDetailsStore, popupReducer } from './popupReducer';
import { progressReducer, ProgressStore } from './progressReducer';
import { templateReducer, TemplateStore } from './templateReducer';
import { dashboardReducer, DashboardStore } from './dashboardReducer';
import { clientReportsReducer, ClientReportStore } from './clientReportsReducer';
import { registerReducer, RegisterStore } from './registerReducer';

export interface RootStore {
	campaign: CampaignStore;
	errorHandler: ErrorHandlerStore;
	progress: ProgressStore;
	advertisement: AdvertisementStore;
	popup: PopupDetailsStore;
	deviceType: DeviceTypeStore;
	template: TemplateStore;
	dashboard: DashboardStore;
	clientReport: ClientReportStore;
	register: RegisterStore;
}
const rootReducer = combineReducers({
	campaign: campaignReducer,
	errorHandler: errorHandlerReducer,
	progress: progressReducer,
	advertisement: advertisementReducer,
	popup: popupReducer,
	deviceType: deviceTypeReducer,
	template: templateReducer,
	dashboard: dashboardReducer,
	clientReport: clientReportsReducer,
	register: registerReducer,
});

export default rootReducer;
